<template>
  <mds-layout-grid v-if="canRender">
    <filter-section />
    <table-section />
  </mds-layout-grid>
</template>

<script>
import FilterSection from '@/components/exchange-monitor/filters/FilterSection';
import TableSection from '@/components/exchange-monitor/table/TableSection';
import { MODULE, COMMON } from '@/constants/store.constant';
import ROUTES from '@/constants/routes.constant';

export default {
  name: 'ProvidersPageEM',
  components: {
    FilterSection,
    TableSection,
  },
  data () {
    return {
      canRender: false,
    };
  },
  async created () {
    const documentGroup = localStorage.getItem('emDocumentGroup');

    if (!documentGroup) {
      localStorage.removeItem('emDocumentGroup');
      this.$router.push({ name: ROUTES.SELECTAPP });
      return;
    }

    const currentDocGroup = this.$store.state[MODULE.EXCHANGE_MONITORS]?.params?.documentGroup;
  
    if (documentGroup && documentGroup !== currentDocGroup) {
      this.$store.commit(`${MODULE.EXCHANGE_MONITORS}/${COMMON.UPDATE_PARAM}`, {
        name: 'documentGroup',
        value: documentGroup
      });
      this.$store.commit(`${MODULE.EXCHANGE_MONITORS}/${COMMON.UPDATE_PARAM}`, {
        name: 'page',
        value: 0
      });
      this.$store.commit(`${MODULE.EXCHANGE_MONITORS}/${COMMON.UPDATE_STATE}`, {
        name: 'shouldRefresh',
        value: true
      });
    }
    this.canRender = true;
  },
};
</script>
